<script setup lang="ts">
import RevalidationStepBox from './RevalidationStepBox.vue'

const steps = [
  {
    image: '/images/revalida1.svg',
    title: 'Verifique cada instalação a ser revalidada',
    items: [
      'A instalação deve ter sido totalmente concluída;',
      'A planta de monitoramento já deve ter sido criada no portal do inversor;',
      'O inversor deve estar online e gerando energia.',
    ],
  },
  {
    image: '/images/revalida2.svg',
    title: 'Preencha e envie os dados do inversor',
    items: [
      'Preencha abaixo o número de série do inversor e o nome da planta que você cadastrou no portal de monitoramento;',
      'Conecte-se ao portal e envie a revalidação.',
    ],
  },
]
</script>

<template>
  <div class="revalidations-intro-steps">
    <p class="revalidations-intro">
      Faça a revalidação de suas instalações em dois passos:
    </p>

    <div class="revalidations-steps">
      <RevalidationStepBox
        v-for="step in steps"
        :key="step.title"
        :image="step.image"
        :title="step.title"
        :items="step.items"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
.revalidations-intro-steps {
  @apply flex flex-col gap-7;
  @apply w-full;

  > .revalidations-intro {
    @apply fonts-body-medium-regular;
    @apply text-neutral-low-light;
  }

  > .revalidations-steps {
    @apply flex flex-col;
    @apply w-full gap-2xs;

    @screen md:system {
      @apply flex-row;
    }
  }
}
</style>
